import React from 'react';
import { useLocale } from '../contexts/LocaleContext';
import { EmptyStateAddButton } from './EmptyStateAddButton';
import { PanelEmptyState } from './PanelEmptyState';
import { ChaptersEmptyIllustration } from './empty-illustration';

interface ChaptersEmptyStateProps {
  canEdit?: boolean;
  onAdd?: () => void;
  title?: string;
  description?: string;
}

export const ChaptersEmptyState: React.FC<ChaptersEmptyStateProps> = ({
  canEdit = false,
  onAdd,
  title,
  description,
}) => {
  const { t } = useLocale();

  return (
    <PanelEmptyState
      illustration={<ChaptersEmptyIllustration />}
      title={title ?? t('chapters_empty_title')}
      description={description ?? t('chapters_empty_description')}
      actions={canEdit && onAdd ? <EmptyStateAddButton onClick={onAdd}>{t('add_chapter')}</EmptyStateAddButton> : undefined}
    />
  );
};
